import { StatTotal, StatLabel, SplitVal } from '../common';
import type { StatStripData } from './types';

export interface BookingsStatStripProps {
  stats: StatStripData;
}

// Four-card today snapshot (Tara OQ-6, prototype statStrip):
// Current dogs / Yesterday / Today / Tomorrow — the three days each split
// arriving/leaving. Read display.
export function BookingsStatStrip({ stats }: BookingsStatStripProps) {
  return (
    <div className="bw-stats four">
      <div className="bw-stat">
        <StatTotal
          icon="paw"
          label="Current dogs"
          total={stats.currentDogsTotal}
          parts={[
            { label: 'Big', value: stats.currentDogsBig },
            { label: 'Little', value: stats.currentDogsLittle },
            { label: 'House', value: stats.currentDogsHouse },
            { label: 'Other', value: stats.currentDogsOther },
          ]}
        />
      </div>
      <div className="bw-stat">
        <StatLabel icon="calendar">Yesterday</StatLabel>
        <SplitVal a={stats.arrivingYesterday} b={stats.leavingYesterday} />
      </div>
      <div className="bw-stat">
        <StatLabel icon="calendar-today">Today</StatLabel>
        <SplitVal a={stats.arrivingToday} b={stats.leavingToday} />
      </div>
      <div className="bw-stat">
        <StatLabel icon="calendar">Tomorrow</StatLabel>
        <SplitVal a={stats.arrivingTomorrow} b={stats.leavingTomorrow} />
      </div>
    </div>
  );
}
